import type { Gdal } from "./gdalRuntime";

let gdalPromise: Promise<Gdal> | undefined;

/** The GDAL runtime, downloaded on first use and reused thereafter. */
export const loadGdal = (): Promise<Gdal> => {
  gdalPromise ??= import("./gdalRuntime")
    .then(({ initialiseGdal }) => initialiseGdal())
    .catch((error) => {
      // Discard the rejected promise so a failed download can be retried.
      gdalPromise = undefined;
      throw error;
    });

  return gdalPromise;
};
